<template>
  <button class="btn" :class="[props.btnClass, props.class]"> {{props.title}} </button>
</template>

<script setup>
const props = defineProps({
  btnClass: {
    type: String,
    default: 'main-btn'
  },
  class: {
    type: String,
    default: ''
  },
  title: {
    type: String,
    default: 'Кликни меня'
  }
})
</script>
